/**
 * Centralized configuration for environment variables
 * 
 * React Scripts automatically loads the correct .env file based on NODE_ENV:
 * - npm start (development) -> loads .env.development
 * - npm run build (production) -> loads .env or production environment
 * 
 * Use the same variable names in all .env files - React Scripts handles the switching.
 * Example:
 * - .env.development: REACT_APP_SOPHYAPP_API_URL=http://localhost:3001
 * - .env: REACT_APP_SOPHYAPP_API_URL=https://api.production.com
 */

const isProduction = process.env.NODE_ENV === "production";

const getEnvVar = (key: string, fallback: string = ""): string => {
  return process.env[key] || fallback;
};

export const config = {
  // API URLs
  apiBaseUrl: getEnvVar("REACT_APP_SOPHYAPP_API_URL", ""),
  
  // Asset URLs
  s3Prefix: getEnvVar("REACT_APP_S3_PREFIX", ""),
  videoUrl: getEnvVar("REACT_APP_SOPHYAPP_VIDEO_URL", ""),
  thumbsUrl: getEnvVar("REACT_APP_SOPHYAPP_THUMBS_URL", ""),
  
  // Third-party services
  stripePublishableKey: getEnvVar("REACT_APP_STRIPE_PUBLISHABLE_KEY", ""),
  
  // App info
  version: getEnvVar("REACT_APP_VERSION", "1.0.1"),
  
  // Environment info
  isProduction,
  isDevelopment: !isProduction,
} as const;

// Legacy function for backward compatibility
export const getApiBaseUrl = (): string => config.apiBaseUrl;

// Helper to check if we're in a specific environment
export const isEnv = (env: "production" | "development"): boolean => {
  return env === "production" ? config.isProduction : config.isDevelopment;
};

